import {PaginationState, ShipmentTypes} from "@store/reducers/shipments.reducer";
import {Shipment} from "@models/shipment.interface";
import {SavedShipment} from "@models/saved-shipment.interface";

export const SHIPMENTS_LOAD = 'SHIPMENTS_LOAD';
export const SHIPMENT_PAGE_LOAD = 'SHIPMENT_PAGE_LOAD';
export const SHIPMENTS_SHIPMENT_REMOVE = 'SHIPMENTS_SHIPMENT_REMOVE';

export const REMOVE_SHIPMENTS = 'REMOVE_SHIPMENTS';
export const UPDATE_SAVED_SHIPMENT = 'UPDATE_SAVED_SHIPMENT';
export const UPDATE_SAVED_SHIPMENT_FAIL = 'EDIT_SAVED_SHIPMENT_FAIL';

export const SHIPMENT_SELECT = 'SHIPMENT_SELECT';
export const SHIPMENT_PAGE_SELECT = 'SHIPMENT_PAGE_SELECT';


export const LOAD_SHIPMENTS_AFTER_REMOVAL = 'LOAD_SHIPMENTS_AFTER_REMOVAL';

export const SET_ACTIVE_SEARCH = 'SET_ACTIVE_SEARCH';
export const SET_FILTERED_SHIPMENTS = 'SET_FILTERED_SHIPMENTS';
export const REMOVE_ACTIVE_SEARCH = 'REMOVE_ACTIVE_SEARCH';

export const CLEAR_SHIPMENTS_STATE = '[SHIPMENTS] CLEAR_STATE';

export class ShipmentsLoad {
  readonly type = SHIPMENTS_LOAD;
  constructor(public payload: PaginationState) {}
}

export class ShipmentPageLoad {
  readonly type = SHIPMENT_PAGE_LOAD;
  constructor(public payload: any) {}
}

export class ShipmentsShipmentRemove {
  readonly type = SHIPMENTS_SHIPMENT_REMOVE;
  constructor(public payload: any) {}
}


export class ShipmentSelect {
  readonly type = SHIPMENT_SELECT;
  constructor(public payload: {
    current_page_size: number,
    current_page: number,
    type: ShipmentTypes,
    id: number,
    isSelected: boolean
  }) {}
}

export class ShipmentPageSelect {
  readonly type = SHIPMENT_PAGE_SELECT;
  constructor(public payload: {
    current_page_size: number,
    current_page: number,
    type: ShipmentTypes,
    isSelected: boolean
  }) {}
}

export class RemoveShipments {
  readonly type = REMOVE_SHIPMENTS;
  constructor(public payload: {
    type: ShipmentTypes,
    current_page_size: number,
    current_page: number,
    ids: number[],
  }) {}
}

export class LoadShipmentsAfterRemoval {
  readonly type = LOAD_SHIPMENTS_AFTER_REMOVAL;
  constructor(public payload: {
    type: ShipmentTypes,
    current_page_size: number,
    current_page: number,
  }) {}
}

export class SetActiveSearch {
  readonly type = SET_ACTIVE_SEARCH;
  constructor(public payload: {
    type: ShipmentTypes,
    activeSearch: string
    current_page_size: number,
    current_page: number
  }) {}
}

export class SetFilteredShipments {
  readonly type = SET_FILTERED_SHIPMENTS;
  constructor(public payload: {
    type: ShipmentTypes,
    activeSearch: string,
    data: Shipment[],
    current_page_size: number,
    current_page: number,
    total: number
  }) {}
}

export class RemoveActiveSearch {
  readonly type = REMOVE_ACTIVE_SEARCH;
  constructor(public payload: {
    type: ShipmentTypes,
  }) {}
}

export class ClearShipmentsState {
  readonly type = CLEAR_SHIPMENTS_STATE;
  constructor() {}
}

export class UpdateSavedShipment {
  readonly type = UPDATE_SAVED_SHIPMENT;
  constructor(
    public payload: SavedShipment
  ) {}
}

export class UpdateSavedShipmentFail {
  readonly type = UPDATE_SAVED_SHIPMENT_FAIL;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/store/actions/shipments.action.ts